module.exports = __webpack_public_path__ + "mz.cbb5e116ed2cd386bc1d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mz.svg
// module chunks = styles